import React from 'react';
import {
  List,
  ListItem,
  Avatar,
  Checkbox,
  Divider,
  MenuItem,
  IconMenu,
  IconButton
} from 'material-ui';
import CreateIcon from "material-ui/svg-icons/content/create";
import { connect } from 'react-redux';
import classNames from 'classnames';
import moment from 'moment';
import _ from 'lodash';
import Modal from 'react-responsive-modal';
import { Form } from 'react-form';
import animateScrollTo from 'animated-scroll-to';
import { injectIntl } from 'react-intl';
import ReactTooltip from 'react-tooltip';

import Translate from 'translate';
import { toggleAlertError, toggleLoading, updateUser } from 'stores/actions';
import { FormGroup, Text, Textarea, Select } from 'components/FormElements';
import InfiniteScroll from '../../../../../../local_modules/react-infinite-scroller';
import PhoneCallModal from 'routes/app/components/Agent/PhoneCallModal/';
import PhoneInfo from 'routes/app/components/Agent/PhoneInfo/';
import ChannelsSearch from 'routes/app/components/Agent/ChannelsSearch';
import CTI from 'routes/app/components/Agent/CTI';
import checkbox from 'assets/images/checkbox.svg'

class ChannelsBar extends React.Component {
  constructor( props ) {
    super( props );
    const { currentFilters } = props;

    this.state = {
      networkFilters: [
        { id: 'twitter', icon: 'fa-twitter', active: currentFilters.filterTwitter },
        { id: 'facebook', icon: 'fa-facebook', active: currentFilters.filterFacebook },
        { id: 'email', icon: 'fa-envelope', active: currentFilters.filterEmail },
        { id: 'phone', icon: 'fa-phone', active: currentFilters.filterPhone },
        { id: 'walk_in', icon: 'fa-user', active: currentFilters.filterWalkIn },
      ],
      returnModalOpened: false,
      channelPhoneModalOpened: false,
      channelsSearchOpened: false,
      createdAt: 'ASC',
      filters: {
        assignedToMe: currentFilters.filterMy,
        service: currentFilters.filterLastService ? Number( currentFilters.filterLastService ) : null,
        category: currentFilters.filterLastCategory,
        words: currentFilters.filterLastWords,
        from: currentFilters.filterLastFrom,
        selectedSocialType: currentFilters.filterFacebook && currentFilters.filterLastViaSocialType && currentFilters.filterLastViaSocialType.indexOf( 'FB_' ) !== -1 ?
          currentFilters.filterLastViaSocialType : currentFilters.filterTwitter && currentFilters.filterLastViaSocialType && currentFilters.filterLastViaSocialType.indexOf( 'FB_' ) === -1 ?
            currentFilters.filterLastViaSocialType || currentFilters.filterLastTwHashTag || currentFilters.filterLastTwAccount : null
      }
    };

    this.reloadData = this.reloadData.bind( this );
    this.submitReturnForm = this.submitReturnForm.bind( this );
    this.toggleReturnModal = this.toggleReturnModal.bind( this );
    this.toggleOrderFilter = this.toggleOrderFilter.bind( this );
    this.toggleChannelPhoneModal = this.toggleChannelPhoneModal.bind( this );
    this.getColorCircleStatus - this.getColorCircleStatus.bind( this );
  }


  componentWillReceiveProps( nextProps ) {
    if( nextProps.reloadChannelDate && this.props.reloadChannelDate !== nextProps.reloadChannelDate ) {
      this.setState( { reloadWarning: true } )
    }
  }

  reloadData( reload = true, isPrev = false ) {
    const { filters, filterText } = this.state;

    this.props.onReloadData( {
      type: _.chain( this.state.networkFilters ).filter( { active: true } ).map( 'id' ).join().value(),
      current_agent: filters.assignedToMe,
      category: filters.category,
      service: filters.service,
      status: filters.status,
      words: filters.words,
      from: filters.from,
      allCriteriaCustomer: filterText,
      viaSocialType: filters.viaSocialType,
      twHashTag: filters.twHashTag,
      twAccount: filters.twAccount,
      createdAtOrder: this.state.createdAt,
      reloadPagination: reload,
      search: 1,
      isPrev: isPrev,
      toggleLoading: true
    } );

    if( reload ) {
      animateScrollTo( 0, {
        element: $( '#channelsBody' )[0],
        maxDuration: 1500,
      } )
    }
  }

  setNetworkFilter( id ) {
    const networkFilters = _.cloneDeep( this.state.networkFilters );
    const filters = _.cloneDeep( this.state.filters );

    let currentFilter = _.find( networkFilters, { id } );
    currentFilter.active = !currentFilter.active;

    const selectedSocialType = _.find( this.props.options.socialAccounts, { id: filters.selectedSocialType } );
    if( selectedSocialType ) {
      if( _.find( networkFilters, { id: 'twitter', active: false } ) && selectedSocialType.type === 'tw') {
        filters.selectedSocialType = null
      }
      if( _.find( networkFilters, { id: 'facebook', active: false } ) && selectedSocialType.type === 'fb' ) {
        filters.selectedSocialType = null
      }
    }
    this.setState( { networkFilters, filters }, () => this.submitFilters( this.state.filters, false ) )
  }

  submitReturnForm( data ) {
    this.props.toggleLoading( true );

    setTimeout( () => {
      this.toggleReturnModal();
      this.props.toggleLoading( false );
    }, 200 )
  }

  toggleOrderFilter() {
    this.setState( { createdAt: this.state.createdAt === 'DESC' ? 'ASC' : 'DESC' }, this.reloadData )
  }

  toggleReturnModal() {
    this.setState( { returnModalOpened: !this.state.returnModalOpened } )
  }

  toggleChannelPhoneModal( phone ,type) {
    this.phoneCalling = phone;
    this.setState({
      phoneCallModalType : type
    })
    this.setState( { channelPhoneModalOpened: !this.state.channelPhoneModalOpened } )
  }

  getColorCircleStatus = ( item ) => {
      let colorStatus= '';
      const status = item.bounced ? 'bounced' : item.status;
      colorStatus = item.status;
      switch (status) {

        case "open":
          colorStatus = 'color-orange' 
          break;
      
        case "bounced":
          colorStatus = 'color-danger' 
          break;
        default:
          break;
      }
      if (item.agent) colorStatus = 'color-orange';
      return colorStatus 
    
  } 
  toggleChannelsSearchModal = () => {
    this.setState( { channelsSearchOpened: !this.state.channelsSearchOpened } )
  };

  submitFilters = ( values = {}, toggleModal = true ) => {
    const filters = values;
    if( values.category && values.category.length && values.category[0].id ) {
      filters.category = _.map( values.category, 'id' )
    }

    const selectedSocialType = _.find( this.props.options.socialAccounts, { id: filters.selectedSocialType } );
    if( selectedSocialType ) {
      if( selectedSocialType.subtype === 'hashtag' ) {
        filters.twHashTag = filters.selectedSocialType;
        filters.twAccount = null;
        filters.viaSocialType = null;
      }
      else if( selectedSocialType.subtype === 'account' ) {
        filters.twAccount = filters.selectedSocialType;
        filters.twHashTag = null;
        filters.viaSocialType = null;
      }
      else if( !selectedSocialType.subtype ) {
        filters.viaSocialType = filters.selectedSocialType;
        filters.twHashTag = null;
        filters.twAccount = null;
      }
    } else {
      filters.viaSocialType = null;
      filters.twHashTag = null;
      filters.twAccount = null;
    }

    this.props.updateUser( {
      filterLastService: filters.service,
      filterLastCategory: filters.category,
      filterLastWords: filters.words,
      filterLastFrom: filters.from,
      filterLastViaSocialType: filters.viaSocialType,
      filterLastTwHashTag: filters.twHashTag,
      filterLastTwAccount: filters.twAccount,
    } );

    this.setState( { filters }, () => this.reloadData() );
    if( toggleModal ) {
      this.toggleChannelsSearchModal();
    }
  };

  renderChannelItem( item, index, firstItem = false ) {
    const { loadChannel, selectedChannels, toggleSelectedChannels, activeChannel, intl, toggleAlertError } = this.props;
    const isSelected = _.find( selectedChannels, { id: item.id } );
    const social = _.get( item, 'type' );
    return (
      <div key={index}
           className={firstItem || isSelected || activeChannel && activeChannel.id === item.id ? 'bg-color-body' : null}
           onClick={() => { 
              if (item.status==='closed') toggleAlertError( intl.formatMessage( { id: 'channelHaveBeenClosed' } ) ); 
              loadChannel( item.id ) 
             } 
           }
      >
        <ListItem
          id={`channel-${item.id}`}
          style={{ borderTop: '1px solid #e5e5e5' }}
          innerDivStyle={{ paddingBottom: 8, paddingTop: 8, width: '100%' }}
          children={
            <div className="row" key={index}>
              <div className="col-md-2 pl-0 text-center">
                <Avatar src={_.get( item, 'webPathThumbnail' )}/>
                <div className="pt-1 d-flex align-items-center justify-content-center">
                  <i className={classNames( 'fa mr-2', {
                    'fa-facebook-square color-facebook': social === 'facebook',
                    'fa-twitter-square color-twitter': social === 'twitter',
                    'fa-envelope color-danger': social === 'email',
                    'fa-phone-square': social === 'phone' && item.lastOperation.via !== 'phone_sms',
                    'fa-commenting-o': social === 'phone' && item.lastOperation.via === 'phone_sms',
                    'fa-user': social === 'walk_in' ,
                  } )}/>
             
                  <i data-tip={intl.formatMessage( { id: "open" } )}
                     className={classNames( 'fa fa-circle text-small',  this.getColorCircleStatus( item )  )}/>
                  <ReactTooltip place="bottom" type="dark" effect="solid"/>
                </div>
              </div>
              <div className="col-md-10">
                <div className="row">
                  <div className="col-md-9 col-lg-10 col-xl-11 p-0">

                    {item.lastOperation && (item.lastOperation.socialType === 'email' || item.lastOperation.private ||  item.lastOperation.via ==='tw_chat' || item.lastOperation.via ==='fb_chat') &&
                         <i data-tip={intl.formatMessage( { id: "Private" } )} 
                            className="fa fa-lock mr-2 color-gray-4"/>
                    }
                    {item.important &&
                         <i data-tip={intl.formatMessage( { id: "important" } )} 
                            className="fa fa-exclamation mr-2 color-danger"/>
                    }
                    {_.get( item, 'name' )}
                    <span className="color-app-light-2 d-block text-normal mt-1 text-truncate">
                        {( item.lastOperation && social !== 'email' ) ? item.lastOperation.content : item.snippet}
                      </span>
                  </div>
                  <div className="col-md-3 col-lg-2 col-xl-1 p-0">
                    <Checkbox
                      uncheckedIcon={<div style={{padding: 3}}><img src={checkbox}/></div>}
                      checked={!!isSelected}
                      onClick={( event ) => {
                        event.stopPropagation();
                        toggleSelectedChannels( item, event.target.checked )
                      }}/>
                  </div>
                </div>
                <div className="row pt-3">
                  <div className="col-12 col-xl-auto p-0">
                    <div className="text-small font-italic">
                      <i className="icon-headset mr-1"/>
                      <span>{item.agent ? `${item.agent.name || ''} ${item.agent.lastname || ''}` :
                        <Translate id="pendingAssignment"/>}
                        </span>
                    </div>
                  </div>
                  <div className="col-auto col-xl text-right pr-1 pl-0">
                              <span className="text-primary text-small text-muted">
                                
                                {!_.get( item, 'lastOperation.socialCreateTime')&&
                                moment( item.updatedAt).format( 'DD/MM/YYYY h:mm A' )
                                }
                                { _.get( item, 'lastOperation.socialCreateTime' ) &&
                                moment( _.get( item, 'lastOperation.socialCreateTime' ) ).format( 'DD/MM/YYYY h:mm A' )
                                }
                              </span>
                  </div>
                </div>
              </div>
            </div>
          }
        />
        <Divider/>
      </div>
    )
  }

  render() {
    const { onReloadChannelPhoneOpenedData, onReloadChannels, data, options, selectedChannels,
      toggleAllChannels, offset, phoneCalling, totalPendingChannels, intl, phoneActive, apiStatus } = this.props;
    const pendingChannels = {
      facebook: totalPendingChannels['facebook'] || 0,
      twitter: totalPendingChannels['twitter'] || 0,
      email: totalPendingChannels['email'] || 0,
      phone: totalPendingChannels['phone'] || 0,
      walkin: totalPendingChannels['walk_in'] || 0,
    };

    //console.log('apiStatus', apiStatus)

    const { filters } = this.state;
    const filtersHasValue = filters && ( filters.assignedToMe || filters.service || ( filters.category && filters.category.length ) ||
      filters.words || filters.status || filters.from || filters.selectedSocialType
    );

    return (
      <div className="box box-default m-0 no-shadow border-right border-gray-1 no-border-radius">
        <div className="box-header p-0 border-bottom-0">

          <div className="row justify-content-between align-items-center m-0 pt-1 pb-2 px-2"
               style={{ boxShadow: '0 2px 4px 0 rgba(0,0,0,0.10)' }}>
            <div className="col-12 col-xl-auto p-0">
              <div className="btn-group">
                {_.map( this.state.networkFilters, ( network, index ) =>
                  network.id !== 'phone' || phoneActive ?
                    <div key={index}
                         data-badge={pendingChannels[network.id]}
                         className={classNames( 'd-inline mdl-badge-network', {
                           'mdl-badge-network-circle': pendingChannels[network.id] < 100,
                           'mdl-badge': pendingChannels[network.id] > 0,
                         } )}
                         style={{ marginRight: 2 }}>
                      <button type="button" disabled={network.disabled}
                              style={{ borderRadius: 4 }}
                              className={classNames( 'btn btn-outline-info btn-fixed-sm', { active: network.active } )}
                              onClick={() => this.setNetworkFilter( network.id )}>
                        <i className={classNames( 'fa', network.icon,  apiStatus[`${network.id}Status`] === 'KO' ? 'color-danger' : '' )}/>
                      </button>
                    </div> : null
                )}
                
              </div>
            </div>

            <div className="col-12 col-xl-auto p-0 pt-1 pt-xl-0">
              <button data-tip={intl.formatMessage( { id: "FilterSection" } )}
                      className={classNames( 'btn btn-fixed-sm', {
                        'btn-secondary': filtersHasValue,
                        'btn-outline-secondary': !filtersHasValue,
                      } )}
                      onClick={this.toggleChannelsSearchModal}
                      style={{ borderRadius: 4, marginRight: 2 }}>
                <i className="fa fa-filter text-normal" />
                <ReactTooltip place="bottom" type="dark" effect="solid"/>
              </button>

              <button disabled data-tip={intl.formatMessage( { id: "OrderTheCases" } )} className="btn btn-outline-secondary btn-fixed-sm" onClick={this.toggleOrderFilter}
                      style={{borderRadius: 4, marginRight: 2}}>
                <i className="fa fa-sort"/>
                <ReactTooltip place="bottom" type="dark" effect="solid"/>
              </button>

              {!!phoneActive &&
              <IconMenu iconButtonElement={<IconButton className="p-0" style={{fontSize:'inherit', width: 24, height: 24 }} touch
                                                     >
                  <button className="btn btn-outline-secondary btn-fixed-sm"> 
                      <i className="fa fa-plus"/>
                  </button> 
                      </IconButton>}
                    >
                    <MenuItem style={{ padding: 5, color: '#333333', lineHeight: '30px', minHeight: 30 }}
                      onClick={() => this.toggleChannelPhoneModal( null,'new' )}>
                              New Cases
                            </MenuItem>
                    <MenuItem style={{ padding: 5, color: '#333333', lineHeight: '30px', minHeight: 30 }}
                            onClick={() => this.toggleChannelPhoneModal( null ,'walkin')}>
                              Walk - in
                            </MenuItem>
                    </IconMenu>
              }
            </div>
          </div>

          <Form onSubmit={( values ) => {this.setState( { filterText: values.search }, () => this.reloadData() )}}>
            {( { submitForm } ) => (
              <form onSubmit={submitForm}>
                <div className="pt-2 px-2 row channels-search">
                  <div className="col-md">
                    <Text field="search" className="form-control" placeholder="typeToSearch" append
                          prefix={<i className="icon-search"/>}/>
                  </div>
                </div>
              </form>
            )}
          </Form>
          <div className="py-2 px-2 row">
           <div className="col-xl-auto">
              <span className={classNames('font-weight-light pointer', {
                'color-app-light': !this.state.reloadWarning,
                'color-danger': this.state.reloadWarning
              })} onClick={() => {
                this.setState( { reloadWarning: false } );
                onReloadChannels()
              }}>
              <Translate id="refreshList"/>
            </span>
             <span className="color-app-light font-weight-light"> | </span>
             <span className="color-app-light font-weight-light pointer" onClick={toggleAllChannels}>
              <Translate
                id={data ? _.intersectionBy(selectedChannels, data, 'id').length === data.length ? 'unselectAll' : 'selectAll' : 'selectAll'}/>
            </span>
           </div>

            <div className="col-xl text-xl-right">
               <span className={classNames( 'font-weight-light pointer', {
                 'color-app-light': offset === 0,
               } )}
                     onClick={() => offset >= 6 ? this.reloadData( false, true ) : {}}>
                <i className="fa fa-angle-double-left mr-1"/>
                <Translate id="prevPage"/>
              </span>
              {' '}
              <span className="color-app-light font-weight-light">-{Math.ceil( offset / 6 ) + 1}-</span>
              {' '}
              <span className={classNames( 'pointer font-weight-light', {
                'color-app-light': !data || data.length < 6 || ( (Math.ceil( offset / 6 ) + 1 ) * 6) >= this.props.totalChannels,
              } )}
                    onClick={() => data && ( data.length >= 6 && ( (Math.ceil( offset / 6 ) + 1 ) * 6) < this.props.totalChannels) ? this.reloadData( false ) : {}}>
              <Translate id="nextPage"/>
              <i className="fa fa-angle-double-right ml-1"/>
            </span>
            </div>
          </div>
        </div>

        <div className={classNames('box-body py-0 pl-1 pr-0', {
          'box-body-channels': !this.props.phoneCalling,
          'box-body-channels-cti': this.props.phoneCalling,
        })} ref="body" id="channelsBody">
          <List style={{padding: 0}}>
            {_.map( data, ( item, index ) => this.renderChannelItem( item, index, false ) )}
          </List>
        </div>

        {phoneCalling && <PhoneInfo phone={phoneCalling} onClick={() => this.toggleChannelPhoneModal( phoneCalling,null )}/>}

        <Modal closeOnEsc={false}
               little
               modalClassName="col-md-6"
               open={this.state.returnModalOpened}
               onClose={this.toggleReturnModal}>
          <h5 className="mt-0"><Translate id="return"/></h5>

          <Form onSubmit={this.submitReturnForm}>
            {( { submitForm } ) =>
              <form onSubmit={submitForm}>
                <FormGroup>
                  <label><Translate id="comment"/></label>
                  <Textarea field="reason" className="form-control" rows={5}/>
                </FormGroup>

                <div className="text-right">
                  <button className="btn btn-info"><Translate id="submit"/></button>
                </div>
              </form>
            }
          </Form>
        </Modal>

        <PhoneCallModal open={this.state.channelPhoneModalOpened}
                        onClose={this.toggleChannelPhoneModal}
                        data={this.phoneCalling ? { phoneCalling } : null, {type:this.state.phoneCallModalType}}
                        onReloadData={onReloadChannelPhoneOpenedData}
        />

        <ChannelsSearch open={this.state.channelsSearchOpened}
                        onClose={this.toggleChannelsSearchModal}
                        options={options}
                        onSubmit={this.submitFilters}
                        filters={filters}
                        networkFilters={this.state.networkFilters}
        />
      </div>
    )
  }
}

const mapStateToProps = ( state, ownProps ) => ({
  reloadChannelDate: state.channelDetail.reloadChannelDate,
  phoneActive: state.settings.phoneActive,
  apiStatus: state.settings.apiStatus,
});

const mapDispatchToProps = dispatch => ({
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
  updateUser: ( data ) => {
    dispatch( updateUser( data ) );
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( injectIntl( ChannelsBar ) );



// WEBPACK FOOTER //
// ./routes/app/components/Agent/ChannelsBar/index.js